import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";

import { ErrorType } from "../../types";

export const getOTPButtonErrorText = (errorType: ErrorType) => {
  switch (errorType) {
    case "too_many_otp": {
      return typedLocalize("passwordlessLogin.tooManyOTPError");
    }
    case "wrong_otp": {
      return typedLocalize("passwordlessLogin.wrongOTPError");
    }
    case "account_locked": {
      return typedLocalize("passwordlessLogin.accountLockedError");
    }
    case "code_used": {
      return typedLocalize("passwordlessLogin.codeUsedError");
    }
    case "code_expired": {
      return typedLocalize("passwordlessLogin.codeExpiredError");
    }
    default: {
      return typedLocalize("passwordlessLogin.errorFallback");
    }
  }
};
